import { ePrintingStatus } from "../shared/models/api/constants";

let printStatusCheckCount = 0;

export function ICprintDocument(pDocumentURL, accessToken = null) {
  if (window.KioPrintControler == null)
    return;

  pDocumentURL = pDocumentURL.replace("assurcardpreprod.ethias.be", "tests4.assurcard.be");
  pDocumentURL = pDocumentURL.replace("assurcard.ethias.be", "s4.assurcard.be");

  const printStatus  = window.KioPrintControler.IsPrinterReady();
  console.log("Kio2 : Has printer no paper error  :",printStatus);
  if (window.KioPrintControler.IsPrinterReady()) {

    printStatusCheckCount = 30;
    //------------New printing method, integrated in Kio2
    setTimeout(function () {
      window.KioPrintControler.PrintDocument(pDocumentURL, accessToken);
    }, 100);
    //setTimeout(CheckPrintingStatus, 500);

  }
  else {
    console.log("Kio2 : printer not available");
  }

}

export function CheckPrintingStatus(): ePrintingStatus {
  // Wait until the printingstatus is COMPLETE or ERROR

  const status = window.KioPrintControler.PrintStatus();
  console.log("Printing status: " + status);
  printStatusCheckCount--;
  if (printStatusCheckCount < 0) {
    console.log("printStatusCheckCount < 0 -> timeout");
    return ePrintingStatus.ERROR;
  }
  else if (status == "PRINTING" || status == "BUSY") {
    console.log("Next polling in 2 seconds or less");
    //setTimeout(CheckPrintingStatus, 2000);
    return ePrintingStatus.PRITING;
  }
  else {
    console.log("Printing status: " + status + " -> stop monitoring");
    return ePrintingStatus.COMPLETE;
  }
}
